<div class="paginator-container">
  <mat-chip-list class="ml-2" *ngIf="processamentosSelecionados.length > 0">
    <mat-chip class="paginator-container__selected ml-2 chip-yellow" [selected]="processamentosSelecionados.length > 0">
      {{ processamentosSelecionados.length }}
      {{ processamentosSelecionados.length > 1 ? 'Carteiras selecionadas' : 'Carteira selecionada' }}
    </mat-chip>
  </mat-chip-list>

  <mat-paginator
    class="w-100"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSizeDefault"
    showFirstLastButtons
  >
  </mat-paginator>
</div>

<div class="table-container overflow-auto">
  <table id="table-periodo" mat-table [dataSource]="dataSource" class="w-100 table-striped">
    <ng-container matColumnDef="processamentosSelecionados">
      <th mat-header-cell *matHeaderCellDef>
        <strong>Carteiras</strong>
      </th>
      <td mat-cell *matCellDef="let processamento">
        {{ processamento.carteira }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
